<app-global-loading />

<app-supervision-banner />

@if (!fullScreen()) {
  <app-header />
}

<main class="shell">
  <router-outlet />
</main>

@if (!fullScreen()) {
  <app-footer />
}

<app-auth-modals-host />
